import moment from 'moment'
export const parseFieldScan = ({
	type,
	document_number,
	issuer,
	issued_at,
	invalid_at
}) => ({
	type,
	document_number,
	issuer,
	issued_at,
	invalid_at
})

export const validateDataStartEnd = (start, end) => {
	let parts_start = start ? start.split(".") : ''
	let st = new Date(parseInt(parts_start[2], 10),
		parseInt(parts_start[1], 10) - 1,
		parseInt(parts_start[0], 10))

	let parts_end = end ? end.split(".") : ''
	let en = new Date(parseInt(parts_end[2], 10),
		parseInt(parts_end[1], 10) - 1,
		parseInt(parts_end[0], 10))

	return moment(st).isSameOrAfter(en)
}

export const getDateNow = () => {
	return moment().format('YYYY-MM-DD')
}

export const localeHeadersWorkers = (headers, func) =>
headers.map(item => ({
	...item,
	text: func(`workers.${item.text}`),
}))

export const localeHeadersPersonalFinances = (headers, func) =>
headers.map(item => ({
	...item,
	text: func(`personal_finance.${item.text}`),
}))

export const localeHeadersAddress = (headers, func) =>
headers.map(item => ({
	...item,
	text: func(`address.${item.text}`),
}))

export const localeHeadersAgency = (headers, func) =>
headers.map(item => ({
	...item,
	text: func(`agencies.${item.text}`),
}))

export const getDates = () => {
	const m = moment().utcOffset(0)
	m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
	const start = m.startOf('month').format('DD.MM.YYYY')
	const end = m.endOf('month').format('DD.MM.YYYY')
	return {
		start,
		end
	}
}
